import { Button } from '@/components/ui/button';
import {
    NodeBody,
    NodeContainer,
    NodeDataKeyWarningIcon,
    NodeErrorIcon,
    NodeHeader,
    NodePrompts,
} from '@/nodes/NodeUI';
import type { GuideNodeId } from '@rock/types';
import { outgoingHandles, RoomTypeLabels } from '@rock/types';
import { Handle, type NodeProps, Position } from '@xyflow/react';
import type { FC } from 'react';
import type { RoomStarterSelectionNodeType } from './types';

export const RoomStarterSelectionNode: FC<NodeProps<RoomStarterSelectionNodeType>> = ({ id, selected, data }) => {
    const paths = outgoingHandles['room-starter-selection'](id as GuideNodeId, data);

    return (
        <NodeContainer>
            <NodeErrorIcon id={id} />
            <NodeDataKeyWarningIcon id={id} />
            <NodeHeader id={id} type={data.type} title={data.pageTitle} />
            <NodeBody selected={selected}>
                <div className="relative">
                    <NodePrompts prompts={data.prompts} />
                    <Handle type="target" position={Position.Left} />
                </div>
                <div className="flex flex-col items-stretch">
                    <div className="p-1 text-xs">Selection: {data.dataKey}</div>
                    <div className="p-1 text-xs">
                        Pre-checked:{' '}
                        {data.preselectRoomTypes.length
                            ? data.preselectRoomTypes.map((t) => RoomTypeLabels[t]).join(', ')
                            : '(none)'}
                    </div>
                    <div className="flex flex-col items-center relative p-1 mb-2 mt-2">
                        <Button variant="link" size="sm">
                            {data.doneLabel || 'Done'}
                        </Button>
                        <Handle type="source" id={paths.done} position={Position.Right} />
                    </div>
                </div>
            </NodeBody>
        </NodeContainer>
    );
};

export default RoomStarterSelectionNode;
